import { render, staticRenderFns } from "./BaseDocumentationCard.vue?vue&type=template&id=905bd2c6&scoped=true&"
import script from "./BaseDocumentationCard.vue?vue&type=script&lang=js&"
export * from "./BaseDocumentationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905bd2c6",
  null
  
)

export default component.exports